import React, { useEffect, useState } from "react";
import { Button, Form, Input, Select, Checkbox, Modal } from "antd";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";

import { crud } from "@/redux/crud/actions";
import { selectListItems } from "@/redux/crud/selectors";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import TextArea from "antd/lib/input/TextArea";


export default function ListingRequestView() {
  let { id } = useParams();
  let [data, setData] = useState([]);
  let [note, setNote] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    axios(`${API_BASE_URL}request-listing/read/${id}`)
      .then(res => {
        
        setData(res.data.result)
      })
      .catch(err => {
      
        
      })
  }, []);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const approve = () => {

    data.status = true
    dispatch(crud.update('request-listing', id, data))
      .then(res => {
        setData(datas => ({
          ...datas,
          status: true
        }))
      
        
      })
      .catch(err => {
      
        
      })
      ;
  }
  const disApprove = () => {
    
    data.status = false
    dispatch(crud.update('request-listing', id, data))
      .then(res => {
        setData(datas => ({
          ...datas,
          status: false
        }))
        setIsModalVisible(false);
      })
      .catch(err => {
     
        
      })
      ;
  }
  function onChange ({ target: { value } }) {
    setNote(value)
  };
  return (
    <>
      <h2> User ID: {data.category_id}</h2>
      <h2> Category one: {data.subcategory_id}</h2>
      <h2> Status : {data.status ? "Approve" : "Disapprove"}</h2>
      <Modal title="Basic Modal" visible={isModalVisible} onOk={disApprove} onCancel={handleCancel}>
        <TextArea
          value={note}
          onChange={onChange}
          autoSize={{ minRows: 3, maxRows: 5 }}
        />
      </Modal>
      {(() => {
        if (!data.status) {
          return (
            <>
              <Button type="primary" onClick={approve}>
                Approve
              </Button>
              <Button type="danger" onClick={showModal}>
                Disapprove
              </Button>
            </>
          )
        }
      })()}

    </>
  );
}
